import React, { Component } from 'react'

import './Foot.scss'
import classnames from "classnames";
class Foot extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentUrl: ''
    }
  }

  componentDidMount(){
    const currentUrl = encodeURIComponent(location.href)
    this.setState({
      currentUrl
    })
  }

  render() {
    const {router} = this.props

    return (
      <div className="footer">
        <div className="foot_nav_bg">
          <div className="footerNav">
            <ul className="footerMenu clearfix">
              <li><a href="/">首页</a></li>
              <li><a href="#product">产品与服务</a></li>
              <li><a href="#news">新闻中心</a></li>
              {/* <li><a href="#cooperate">合作伙伴</a></li> */}
              <li><a href="/aboutUs/company">关于我们</a></li>
            </ul>
            <ul className="footerInfo clearfix">
              <li>
                <img src={require('./images/iphone.png')}/>
                <span>4009-160-160</span>
              </li>
              <li>
                <img src={require('./images/addr.png')}/>
                <span>上海市嘉定区嘉罗公路1661弄12号101室—11</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="foot_panel_bg">
          <div className="footerPanel clearfix">
            <div className="panel">
              <ul className="panelLeft clearfix">
                <li>
                  <dl>
                    <dd><a href="./services/huoke">智能获客</a></dd>
                    <dd><a href="./services/fengkong">智能风控</a></dd>
                    <dd><a href="./services/jiqiren">智能机器人</a></dd>
                  </dl>
                </li>
                <li>
                  <dl>
                    <dd><a href="./services/automl">自动建模平台</a></dd>
                    <dd><a href="./services/saas">海外SaaS服务</a></dd>
                    <dd><a href="./services/fangan">一站式信贷解决方案</a></dd>
                  </dl>
                </li>
                <li>
                  <dd><a href="./aboutUs/news">新闻中心</a></dd>
                  <dd><a href="./aboutUs/company">公司介绍</a></dd>
                  <dd><a href="./aboutUs/shareholder">股东介绍</a></dd>
                </li>
                <li>
                  <dl>
                    <dd><a href="./aboutUs/management">高管团队</a></dd>
                    <dd><a href="./aboutUs/honor">公司荣誉</a></dd>
                    <dd><a href="./aboutUs/responsibility">社会责任</a></dd>
                  </dl>
                </li>
              </ul>
              <div className="panelRight">
                <ul>
                  <li>
                    <img src={require('./images/wechat-img.jpg')} alt="企微客服二维码" title="企微客服二维码" />
                    <p>企微客服</p>
                  </li>
                  {/* <li>
                    <img src={require('./images/guanfangAPP.png')} alt="官方APP" title="官方APP"/>
                    <p>官方APP</p>
                  </li> */}
                  <li>
                    <img src={require('./images/footer_subscription.jpg')} alt="官方订阅号" title="官方订阅号" />
                    <p>官方订阅号</p>
                  </li>
                </ul>
                <dl>
                  <dd>
                    <a href="http://weibo.com/u/5669931247" rel="nofollow" target="_blank" title="新浪微博">
                      <img src={require('./images/sina.png')}/>
                    </a>
                  </dd>
                  <dd>
                    <a href={`/qrCode?currentUrl=${this.state.currentUrl}`} rel="nofollow" target="_blank"  title="微信">
                      <img src={require('./images/weixin.png')}/>
                    </a>
                  </dd>
                  <dd>
                    <a href="http://t.qq.com/CTCFZTX" rel="nofollow" target="_blank"  title="腾讯微博">
                      <img src={require('./images/tencent.png')}/>
                    </a>
                  </dd>
                  <dd>
                    <a href="javascript:void(0);" rel="nofollow" title="联系电话">
                      <img src={require('./images/tel.png')}/>
                      <span>4009-160-160</span>
                    </a>
                  </dd>
                </dl>
              </div>
            </div>
            <p className="statement">
              中腾信金融信息服务（上海）有限公司 <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" rel="nofollow">沪ICP备14018099号-1号</a>  丨  Copyright © 2016 Chinatopcredit Inc. All rights reserved
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export { Foot }



// WEBPACK FOOTER //
// ./components/layout/Foot.js